import { X } from "lucide-react";

export function ActionDialog({ isOpen, onClose, children, className = "" }) {
  return isOpen ? (
    <div className="relative z-50" open={isOpen} onClose={onClose}>
      <div className="fixed inset-x-0 bottom-0 overflow-y-auto">
        <div className="flex justify-center p-4">
          <div
            className={`w-auto transform overflow-hidden rounded-xl 
                        bg-white px-6 py-3 text-left align-middle shadow-[0_4px_20px_rgba(0,0,0,0.12)] transition-all ${className}`}
          >
            <div className="flex items-center gap-6">
              {children}
              <button
                onClick={onClose}
                className="text-gray-600 hover:text-gray-800 focus:outline-none"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
